
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchDownloadCategories } from './fetch-download-categories';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  initialData?: P | null,
  staleTime?: number
};

/**
 * Action type.
 */

const actionType = ({ locale }): string => {
  return `${locale}-download-categories`;
};

/**
 * `useDownloadCategories` hook.
 */

function useDownloadCategories<P>({ initialData, staleTime }: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const result = useQuery([actionType(variables), variables], () => {
    return fetchDownloadCategories(variables);
  }, {
    initialData,
    staleTime
  });

  return result;
}

/**
 * Export `useDownloadCategories` hook.
 */

export default useDownloadCategories;
